import { useState } from "react";
import { format } from "date-fns";
import {
  Box,
  IconButton,
  TableCell,
  TableRow,
  TableSortLabel,
  Tooltip,
} from "@mui/material";
import { Link } from "react-router-dom";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CustomTable from "../../components/CustomTable";
import { StyledTableCell } from "../../components/styled";
import {
  TransactionType,
  getTransactions,
} from "../../services/transaction.service";
import { DATE_TIME_FORMAT } from "../../utils/constants";
import { copyToClipboard, truncateId } from "../../utils/helpers";

const renderRow = (transaction) => (
  <TableRow key={transaction.id}>
    <TableCell>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Tooltip title={transaction.id}>
          <span>{truncateId(transaction.id)}</span>
        </Tooltip>

        <IconButton
          size="small"
          onClick={(event) => copyToClipboard(transaction.id, event)}
          sx={{ padding: 0.5 }}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Box>
    </TableCell>

    <TableCell>
      {transaction.user ? (
        <Box>
          <Box
            component={Link}
            to={`/users/${transaction.user.id}`}
            sx={{
              color: "inherit",
              textDecoration: "underline",
            }}
          >
            {truncateId(transaction.user.id)}
          </Box>
          <Box>
            {transaction.user.username
              ? `@${transaction.user.username}`
              : "N/A"}
          </Box>
        </Box>
      ) : (
        "N/A"
      )}
    </TableCell>

    <TableCell sx={{ textTransform: "capitalize" }}>
      {transaction.type || "N/A"}
    </TableCell>

    <TableCell>{transaction.amount ?? transaction.credits ?? "N/A"}</TableCell>

    <TableCell>
      {transaction.source || transaction.sourceType || "N/A"}
    </TableCell>

    <TableCell>
      {transaction.createdAt
        ? format(new Date(transaction.createdAt), DATE_TIME_FORMAT)
        : "N/A"}
    </TableCell>
  </TableRow>
);

const typeFilterOptions = Object.values(TransactionType).map((value) => ({
  value,
  label: value.charAt(0).toUpperCase() + value.slice(1),
}));

const Transactions = () => {
  const [sortOrder, setSortOrder] = useState("DESC");

  const toggleSortOrder = () => {
    setSortOrder((prev) => (prev === "DESC" ? "ASC" : "DESC"));
  };

  const renderHeader = () => (
    <TableRow>
      <StyledTableCell>ID</StyledTableCell>
      <StyledTableCell>User</StyledTableCell>
      <StyledTableCell>Type</StyledTableCell>
      <StyledTableCell>Amount (tokens)</StyledTableCell>
      <StyledTableCell>Source</StyledTableCell>
      <StyledTableCell>
        <TableSortLabel
          active
          direction={sortOrder === "ASC" ? "asc" : "desc"}
          onClick={toggleSortOrder}
        >
          Created At
        </TableSortLabel>
      </StyledTableCell>
    </TableRow>
  );

  return (
    <CustomTable
      name="transactions"
      getItemsMethod={getTransactions}
      renderHeader={renderHeader}
      renderRow={renderRow}
      columnCount={6}
      filters={{
        type: {
          type: "select",
          label: "Type",
          options: typeFilterOptions,
          defaultValue: "",
          paramName: "type",
          minWidth: 180,
        },
      }}
      queryKeyParts={[sortOrder]}
      queryParams={{ sortOrder }}
      pageResetKey={sortOrder}
    />
  );
};

export default Transactions;
